// store/admin/certificates/store/_actions.js
import * as types from './_actionTypes';

// =====================================================
// CERTIFICATES LIST
// =====================================================
export const fetchCertificatesRequest = (filters = {}) => ({
  type: types.FETCH_CERTIFICATES_REQUEST,
  payload: filters
});

export const fetchCertificatesSuccess = (data) => ({
  type: types.FETCH_CERTIFICATES_SUCCESS,
  payload: data
});

export const fetchCertificatesFailure = (error) => ({
  type: types.FETCH_CERTIFICATES_FAILURE,
  payload: error
});

// =====================================================
// CERTIFICATE BY ID
// =====================================================
export const fetchCertificateByIdRequest = (certificateId) => ({
  type: types.FETCH_CERTIFICATE_BY_ID_REQUEST,
  payload: certificateId
});

export const fetchCertificateByIdSuccess = (certificate) => ({
  type: types.FETCH_CERTIFICATE_BY_ID_SUCCESS,
  payload: certificate
});

export const fetchCertificateByIdFailure = (error) => ({
  type: types.FETCH_CERTIFICATE_BY_ID_FAILURE,
  payload: error
});

// =====================================================
// PENDING APPROVALS
// =====================================================
export const fetchPendingApprovalsRequest = (params) => ({
  type: types.FETCH_PENDING_APPROVALS_REQUEST,
  payload: params // { college_id, course_id, page, limit }
});

export const fetchPendingApprovalsSuccess = (data) => ({
  type: types.FETCH_PENDING_APPROVALS_SUCCESS,
  payload: data
});

export const fetchPendingApprovalsFailure = (error) => ({
  type: types.FETCH_PENDING_APPROVALS_FAILURE,
  payload: error
});

// =====================================================
// CERTIFICATE STATS
// =====================================================
export const fetchCertificateStatsRequest = (filters = {}) => ({
  type: types.FETCH_CERTIFICATE_STATS_REQUEST,
  payload: filters
});

export const fetchCertificateStatsSuccess = (stats) => ({
  type: types.FETCH_CERTIFICATE_STATS_SUCCESS,
  payload: stats
});

export const fetchCertificateStatsFailure = (error) => ({
  type: types.FETCH_CERTIFICATE_STATS_FAILURE,
  payload: error
});

// =====================================================
// APPROVE CERTIFICATE (Single)
// =====================================================
export const approveCertificateRequest = (data) => ({
  type: types.APPROVE_CERTIFICATE_REQUEST,
  payload: data // { student_id, course_id }
});

export const approveCertificateSuccess = (certificate) => ({
  type: types.APPROVE_CERTIFICATE_SUCCESS,
  payload: certificate
});

export const approveCertificateFailure = (error) => ({
  type: types.APPROVE_CERTIFICATE_FAILURE,
  payload: error
});

// =====================================================
// ISSUE MANUAL CERTIFICATE
// =====================================================
export const issueManualCertificateRequest = (data) => ({
  type: types.ISSUE_MANUAL_CERTIFICATE_REQUEST,
  payload: data // { student_id, course_id }
});

export const issueManualCertificateSuccess = (result) => ({
  type: types.ISSUE_MANUAL_CERTIFICATE_SUCCESS,
  payload: result // { certificate, alreadyExists, message }
});

export const issueManualCertificateFailure = (error) => ({
  type: types.ISSUE_MANUAL_CERTIFICATE_FAILURE,
  payload: error
});

export const clearIssueManualResult = () => ({
  type: types.CLEAR_ISSUE_MANUAL_RESULT
});

// =====================================================
// BULK APPROVE CERTIFICATES
// =====================================================
export const bulkApproveCertificatesRequest = (data) => ({
  type: types.BULK_APPROVE_CERTIFICATES_REQUEST,
  payload: data // { college_id, course_id, student_ids? }
});

export const bulkApproveCertificatesSuccess = (result) => ({
  type: types.BULK_APPROVE_CERTIFICATES_SUCCESS,
  payload: result
});

export const bulkApproveCertificatesFailure = (error) => ({
  type: types.BULK_APPROVE_CERTIFICATES_FAILURE,
  payload: error
});

// =====================================================
// REVOKE CERTIFICATE
// =====================================================
export const revokeCertificateRequest = (data) => ({
  type: types.REVOKE_CERTIFICATE_REQUEST,
  payload: data // { certificateId, reason }
});

export const revokeCertificateSuccess = (certificate) => ({
  type: types.REVOKE_CERTIFICATE_SUCCESS,
  payload: certificate
});

export const revokeCertificateFailure = (error) => ({
  type: types.REVOKE_CERTIFICATE_FAILURE,
  payload: error
});

// =====================================================
// VERIFY CERTIFICATE
// =====================================================
export const verifyCertificateRequest = (certificateNumber) => ({
  type: types.VERIFY_CERTIFICATE_REQUEST,
  payload: certificateNumber
});

export const verifyCertificateSuccess = (result) => ({
  type: types.VERIFY_CERTIFICATE_SUCCESS,
  payload: result
});

export const verifyCertificateFailure = (error) => ({
  type: types.VERIFY_CERTIFICATE_FAILURE,
  payload: error
});

// =====================================================
// COLLEGES & COURSES (Dropdowns)
// =====================================================
export const fetchCollegesRequest = () => ({
  type: types.FETCH_COLLEGES_REQUEST
});

export const fetchCollegesSuccess = (colleges) => ({
  type: types.FETCH_COLLEGES_SUCCESS,
  payload: colleges
});

export const fetchCollegesFailure = (error) => ({
  type: types.FETCH_COLLEGES_FAILURE,
  payload: error
});

export const fetchCoursesRequest = () => ({
  type: types.FETCH_COURSES_REQUEST
});

export const fetchCoursesSuccess = (courses) => ({
  type: types.FETCH_COURSES_SUCCESS,
  payload: courses
});

export const fetchCoursesFailure = (error) => ({
  type: types.FETCH_COURSES_FAILURE,
  payload: error
});

// =====================================================
// UI STATE
// =====================================================
export const setSelectedCollege = (collegeId) => ({
  type: types.SET_SELECTED_COLLEGE,
  payload: collegeId
});

export const setSelectedCourse = (courseId) => ({
  type: types.SET_SELECTED_COURSE,
  payload: courseId
});

export const clearCertificateError = () => ({
  type: types.CLEAR_CERTIFICATE_ERROR
});

export const resetCertificateState = () => ({
  type: types.RESET_CERTIFICATE_STATE
});